import { render, staticRenderFns } from "./UpdateStatementModal.vue?vue&type=template&id=58f7a813&"
import script from "./UpdateStatementModal.vue?vue&type=script&lang=js&"
export * from "./UpdateStatementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports